import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from 'react';
import Checkbox from '@precis-digital/kurama/Checkbox';
import type { ChartDataRow } from '../../../types';
import type { Row } from '@tanstack/react-table';
interface TableBodyCellRowSelectionProps<DataKey extends string, DataRow extends ChartDataRow<DataKey>> {
  row: Row<DataRow>;
  rowSelected: boolean;
}
const TableBodyCellRowSelection = t0 => {
  const $ = _c(5);
  const {
    row,
    rowSelected
  } = t0;
  let t1;
  if ($[0] !== row) {
    t1 = row.getToggleSelectedHandler();
    $[0] = row;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== rowSelected || $[3] !== t1) {
    t2 = <Checkbox checked={rowSelected} onChange={t1} />;
    $[2] = rowSelected;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default TableBodyCellRowSelection;